export default {
    "slug": "hero",
    "title": "Hero Tactics II",
    "introduction": "5 year anniversary",
    "firstChapterKey": "prologue",
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        "Doc McPherson",
        "Vinícius Menézio",
        "Landon Ashby",
    ],
    "configuration": {
        "darkness": "none",
        "squigglevision": false,
        "encounterViewOnly": true,
    },
    // "chapters": require("./chapters").default,
    "player": require("./player").default,
    "chapters": {
        "prologue": require("./prologue").default,
        "introduce-mercenary": require("./introduce-mercenary").default,
        "introduce-archer": require("./introduce-archer").default,
        "upgrade-mercenary": require("./upgrade-mercenary").default,
        "introduce-cleric": require("./introduce-cleric").default,
        "upgrade-archer": require("./upgrade-archer").default,
        "defeat-miniboss": require("./defeat-miniboss").default,
        "upgrade-cleric": require("./upgrade-cleric").default,
        "defeat-boss": require("./defeat-boss").default,
    },
    "audio": {
        "Music:Title": {
            "volume": 0.4,
            "loop": true,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/hero-2.wav")),
        },
        "Music:YourTurn": {
            "volume": 0.4,
            "loop": true,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/hero-1.wav")),
        },
        "Music:EnemyTurn": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/evil.wav")),
        },
        "Music:Overworld": {
            "volume": 0.4,
            "loop": true,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/overworld.wav")),
        },
        "Stinger:Failure": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/failure.wav")),
        },
        "Stinger:Victory": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/hero-tactics/victory.wav")),
        },
    },
    "overworld": {
        // "image": require("@frog/source/assets/images/overworld.png"),
        "locations": {
            "1": {
                "key": "1",
                "position": {"x": 2, "y": 1},
                "chapterKey": "introduce-mercenary",
                "icon": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/mercenary_good.png"),
                "isDisplayed": true,
                "isReachable": true,
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "1"},
                        {"type": "DisplayLocations", "locationKeys": ["2"]},
                        {"type": "DisplayLocations", "locationKeys": ["3"]},
                        {"type": "DisplayLocations", "locationKeys": ["4"]},
                        {"type": "DisplayLocations", "locationKeys": ["5"]},
                        {"type": "DisplayEventualRoute", "routeKeys": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"]},
                        {"type": "Wait", "time": 1},
                        {"type": "UnlockLocations", "locationKeys": ["2"], "routeKeys": ["1", "2", "3"]},
                    ]
                },
            },
            "2": {
                "key": "2",
                "position": {"x": 3, "y": 3},
                "chapterKey": "introduce-archer",
                "icon": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/rogue_good.png"),
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "2"},
                        {"type": "UnlockLocations", "routeKeys": ["4", "5"], "locationKeys": ["3"]},
                        {"type": "UnlockLocations", "routeKeys": ["A1", "A2"], "locationKeys": ["A"]},
                    ]
                },
            },
            "3": {
                "key": "3",
                "position": {"x": 5, "y": 3},
                "chapterKey": "introduce-cleric",
                "icon": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/cleric_good.png"),
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "3"},
                        {"type": "UnlockLocations", "routeKeys": ["6", "7", "8"], "locationKeys": ["4"]},
                        {"type": "UnlockLocations", "routeKeys": ["B1", "B2", "B3"], "locationKeys": ["B"]},
                    ]
                },
            },
            "4": {
                "key": "4",
                "position": {"x": 4, "y": 5},
                "chapterKey": "defeat-miniboss",
                "icon": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/pagoda_temple_wout_trees.png"),
                "spritesize": "big",
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "4"},
                        {"type": "UnlockLocations", "routeKeys": ["9", "10", "11"], "locationKeys": ["5"]},
                        {"type": "UnlockLocations", "routeKeys": ["C1", "C2"], "locationKeys": ["C"]},
                    ]
                },
            },
            "5": {
                "key": "5",
                "position": {"x": 3, "y": 7},
                "chapterKey": "defeat-boss",
                "icon": require("@frog/source/assets/images/hero-tactics/map/desert/objects/sand_fortress_wout_towers_2.png"),
                "spritesize": "big",
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "CreditsScreen"},
                    ]
                },
            },
            "A": {
                "key": "A",
                "position": {"x": 1, "y": 3},
                "chapterKey": "upgrade-cleric",
                "icon": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png"),
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "A"},
                    ]
                },
            },
            "B": {
                "key": "B",
                "position": {"x": 4, "y": 1},
                "chapterKey": "upgrade-archer",
                "icon": require("@frog/source/assets/images/hero-tactics/map/desert/objects/obelisk-centered.png"),
                "spritedown": true,
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "B"},
                    ]
                },
            },
            "C": {
                "key": "C",
                "position": {"x": 2, "y": 5},
                "chapterKey": "upgrade-mercenary",
                "icon": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/fort_red.png"),
                "spritedown": true,
                "events": {
                    "afterVictory": [
                        {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                        {"type": "FinishLocation", "locationKey": "C"},
                    ]
                },
            },
        },
        "routes": {
            "1": {"x": 2, "y": 1.4},
            "2": {"x": 2.1, "y": 1.9},
            "3": {"x": 2.4, "y": 2.2},
            "4": {"x": 3.66, "y": 2.8},
            "5": {"x": 4.1, "y": 2.9},
            "6": {"x": 4.8, "y": 3.4},
            "7": {"x": 4.7, "y": 3.95},
            "8": {"x": 4.4, "y": 4.4},
            "9": {"x": 4.1, "y": 5.4},
            "10": {"x": 3.9, "y": 6.0},
            "11": {"x": 3.6, "y": 6.3},
            "A1": {"x": 2.2, "y": 2.8},
            "A2": {"x": 1.7, "y": 2.85},
            "B1": {"x": 5.0, "y": 2.1},
            "B2": {"x": 4.7, "y": 1.65},
            "B3": {"x": 4.3, "y": 1.4},
            "C1": {"x": 3.2, "y": 4.8},
            "C2": {"x": 2.7, "y": 4.9},
        }
    },
}
